import React from 'react';
import Children from '../../interfaces/children.interface';
import ClassName from '../../interfaces/class-name.interface';
import TestId from '../../interfaces/test-id.interface';

export interface Props extends Children, ClassName, TestId {}

/** A single tag, usually containing only text */
const Tag = ({ children, className = '', testId }: Props): React.ReactElement => (
  <span
    className={`bg-gray-200 inline-block mr-1 rounded-full px-3 py-1 text-xs ${className}`}
    data-testid={testId}
  >
    {children}
  </span>
);

export default Tag;
